module.exports = __webpack_public_path__ + "static/img/10.99700ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/10.png
// module id = xC/o
// module chunks = 0